var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-ath w-bg"},[_c('div',{staticClass:"row justify-content-center align-items-center",staticStyle:{"height":"100vh","width":"100%"}},[_c('transition',{attrs:{"mode":"out-in","name":"slide"}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }